import { Flex } from '@/components/base';
import type { MappedChartColumn } from '@/features/Dashboard/types/types';

import DashboardRowDropzone from './DashboardRowDropzone';

type DashboardRowDropzoneGroupProps = {
  dashboardId: string;
  rowId: string;
  someDragging: boolean;
  columns: MappedChartColumn[];
};

const DashboardRowDropzoneGroup = (props: DashboardRowDropzoneGroupProps) => {
  return (
    <Flex
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: props.someDragging ? 1 : -1,
        opacity: props.someDragging ? 1 : 0,
      }}
    >
      {props.columns.map((col, i) => (
        <DashboardRowDropzone
          key={col.id}
          zoneIndex={i}
          columns={props.columns}
          dashboardId={props.dashboardId}
          rowId={props.rowId}
          someDragging={props.someDragging}
        />
      ))}

      <DashboardRowDropzone
        zoneIndex={props.columns.length}
        columns={props.columns}
        dashboardId={props.dashboardId}
        rowId={props.rowId}
        someDragging={props.someDragging}
      />
    </Flex>
  );
};

export default DashboardRowDropzoneGroup;
